import { Injectable } from '@angular/core';
import {Observable, observable, Subject} from 'rxjs'
@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
private subject  = new Subject<any>();
private subject1  = new Subject<any>();
  constructor() { }
  pram1=''
  pram2=''
  show(s:any, m:any){
     let obj={screen:s,meassage:m}
    this.subject.next(obj);
  }
 
  showClickEvent():Observable<any>{
      return this.subject.asObservable()
  }
  
  hide(){
    this.subject1.next('');
  }

  hideClickEvent():Observable<any>{
    return this.subject1.asObservable();
}

}
